import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import styled from "styled-components";
import ListComponent from "../../components/ListComponent";

const data = [
    {
        id: 1,
        title: 'Qatar Embassy - Dhaka',
        month: 'january',
        award: 'Honorable Mention',
        year: 2019
    },
    {
        id: 2,
        title: 'IDCOL - Bangladesh',
        month: 'january',
        award: 'Honorable Mention',
        year: 2018
    },
    {
        id: 3,
        title: '7 HOUSE - Residential Building',
        month: 'january',
        award: 'Honorable Mention',
        year: 2018
    },
    {
        id: 4,
        title: 'Police Plaza - Comilla',
        month: 'january',
        award: 'Honorable Mention',
        year: 2017
    },
    {
        id: 5,
        title: 'Police Plaza - Munshiganj',
        month: 'january',
        year: 2017
    },
    {
        id: 6,
        title: 'Police Plaza - Bogura',
        month: 'january',
        award: 'Honorable Mention',
        year: 2017
    },
    {
        id: 1,
        title: 'Qatar Embassy - Dhaka',
        month: 'january',
        award: 'Honorable Mention',
        year: 2019
    },
    {
        id: 2,
        title: 'IDCOL - Bangladesh',
        month: 'january',
        award: 'Honorable Mention',
        year: 2018
    },
    {
        id: 3,
        title: '7 HOUSE - Residential Building',
        month: 'january',
        award: 'Honorable Mention',
        year: 2018
    },
    {
        id: 4,
        title: 'Police Plaza - Comilla',
        month: 'january',
        award: 'Honorable Mention',
        year: 2017
    },
    {
        id: 5,
        title: 'Police Plaza - Munshiganj',
        month: 'january',
        award: 'Honorable Mention',
        year: 2017
    },
    {
        id: 6,
        title: 'Police Plaza - Bogura',
        month: 'january',
        award: 'Honorable Mention',
        year: 2017
    }
]

const PublicLecture = () => {

    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Architech Shamsul Wares | Podcast</title>
                <meta name="Architech Shamsul Wares"
                      content="Our current mode and depiction of existence become almost incomprehensible due to the explosion of unimaginable visual."/>
            </Helmet>
            <StyledComponent>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <ListComponent url={'typology'} data={data} />
                        </Col>
                    </Row>
                </Container>
            </StyledComponent>
        </HelmetProvider>
    );
};

const StyledComponent = styled.section`


`;

export default PublicLecture;